<router-outlet></router-outlet>
               <app-payment-loading></app-payment-loading>
			   <app-add-account-to-policy></app-add-account-to-policy>
               <change-policy-receipts></change-policy-receipts>
               <app-complete-profile-modal></app-complete-profile-modal>
               <app-pop-up-legaliboo></app-pop-up-legaliboo>
               